import React from 'react';
import TemplateProyect from '../TemplateProyect';

function Yoga() {
    const infoTect = ["React", "HTML", "CSS", "JavaScript", "Materialize", "Sass", "", "", "", ""];
    const infoProyect = [
        "Calm Yoga",
        "https://www.youtube.com/embed/TYftpDV9xQk",
        "Page dedicated and focused on areas related to yoga",
        "https://brandongrimaldom.github.io/calmyoga/",
        "/web-development"
    ];

    return (
        <React.Fragment>
            <TemplateProyect
                title={infoProyect[0]}
                video={infoProyect[1]}
                description={infoProyect[2]}
                github={infoProyect[3]}
                tecfilter={infoTect}
                after={infoProyect[4]}  >
            </TemplateProyect>
        </React.Fragment>
    );
}
export default Yoga;